import { useState } from "react";
import MultiButton from "../../Component/extra/MultiButton";
import Organization from "./Organization";
import CreateOrganization from "../../Component/dialogue/CreateOrganization";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";

const OrgPage = () => {
  const [currentTab, setCurrentTab] = useState("Admin Dashboard");

  return (
    <PageContainer>
      <PageHeader heading={"Welcome Admin"} subHeading={"Organization"} />

      <MultiButton
        label={["Admin Dashboard", "Register Organization"]}
        multiButtonSelect={currentTab}
        setMultiButtonSelect={setCurrentTab}
      />

      {currentTab === "Admin Dashboard" && <Organization />}
      {currentTab === "Register Organization" && <CreateOrganization />}
    </PageContainer>
  );
};

export default OrgPage;
